const serverURL =
  process.env.NODE_ENV === "production"
    ? "https://api.flowrota.com/api/v1"
    : `http://${window.location.hostname}:7008/api/v1`;

export default serverURL;
